/** User-facing copy for the MOI Rules tab, following the `texts.ts` convention of its sibling engines
 *  (`FundAccounts/texts.ts`, `SlaEngine/texts.ts`). */
export const TEXTS = {
  TAB_LABEL: 'MOI Rules',
  TITLE: 'MOI Assignment Rules',
  ADD_RULE: 'Add Rule',
  EMPTY_STATE: 'No MOI assignment rules configured yet.',
  DIALOG_TITLE_ADD: 'Add MOI Assignment Rule',
  DIALOG_TITLE_EDIT: 'Edit MOI Assignment Rule',
  SAVE: 'Save',
  UPDATE: 'Update',
  NAME_LABEL: 'Name',
  NAME_REQUIRED: 'Name is required',
  CONTEXT: 'Context',
  SUB_ORGANIZATIONS_LABEL: 'Sub Organizations',
  SUB_ORGANIZATIONS_REQUIRED: 'At least one sub organization must be selected',
  LOBS_REQUIRED: 'At least one LOB must be selected',
  MOI_METHODS_LABEL: 'MOI Methods',
  MOI_METHODS_REQUIRED: 'At least one MOI method must be selected',
  MOI_METHOD_STALE: 'This rule is scoped to an MOI method the organization no longer has — remove it to save.',
  ASSIGNEE: 'Assignee',
  STRATEGY_STATIC: 'Specific contact',
  STRATEGY_ROLE: 'Contact role',
  CONTACT_LABEL: 'Contact',
  CONTACT_REQUIRED: 'Select a contact',
  CONTACT_INELIGIBLE: 'The contact must be an active MOI service provider with an email address',
  CONTACT_LACKS_EXPERTISE: (methodNames: string[]): string =>
    `The contact has none of the expertises these MOI methods the rule covers need: ${methodNames.join(', ')}`,
  ROLE_LABEL: 'Contact role',
  ROLE_REQUIRED: 'Select a contact role',
  ROLE_HELP:
    'The role must have exactly one active MOI service provider with a matching expertise and an email address. Otherwise the Create Inspection claim action refuses the inspection, and in the MOI stepper the user sees why and picks the assignee.',
  SCOPE_CHANGE_NOTE_TITLE: 'Please Note',
  SCOPE_CHANGE_NOTE: 'Editing the sub organizations or lines of business will clear all conditions.',
  CONDITIONS_PREREQUISITE: (subOrgsEnabled: boolean): string =>
    `Select a Line of Business${subOrgsEnabled ? ' and a Sub-Organization' : ''} to configure conditions.`,
  CONDITIONS_EMPTY: 'No condition fields available for this line of business.',
  DELETE_TITLE: 'Delete MOI Assignment Rule?',
  DELETE_TEXT: (name: string): string => `Are you sure you want to delete "${name}"?`,
  CONTACT_FALLBACK: (id: number): string => `Contact #${id}`,
  ROLE_CELL: (desc: string): string => `Role: ${desc}`,
  COLUMN_NAME: 'Name',
  COLUMN_SUB_ORGANIZATIONS: 'Sub Organizations',
  COLUMN_LOB: 'LOB',
  COLUMN_MOI_METHODS: 'MOI Methods',
  COLUMN_ASSIGNEE: 'Assignee',
  COLUMN_ENABLE: 'Enable',
  COLUMN_ACTIONS: 'Actions',
  ALL: 'All',
  SUB_ORG_FALLBACK: (id: number): string => `Sub-Org ${id}`,
  EDIT: 'Edit',
  DELETE: 'Delete',
  ENABLE_RULE_ARIA_LABEL: (name: string): string => `Enable — ${name}`,
};
